import React from 'react';
import styled from 'styled-components';
import { Flex, Box } from '@rebass/grid';
import { getThemeProp } from '@amtrav/themes';
import { IconChatRound, IconPhoneHandle } from '@amtrav/icons';
import { Text } from '@amtrav/view-components';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

const CtaContent = styled(Flex)`
  min-height: 100px;
`;

const Questions = styled(Box)`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`;

const CtaButton = styled.button`
  height: 36px;
  width: 122px;
  font-size: 16px;
  font-family: inherit;
  border-radius: 8px;
  border: 0;
  padding: 0;
  cursor: pointer;
  margin-bottom: 16px;

  &:focus {
    outline: none;
  }
`;

const ChatButton = styled(CtaButton)`
  background: ${getThemeProp('chat.minimized-chat--color')};
  margin-right: 12px;
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
`;

const PhoneButton = styled(CtaButton)`
  color: ${getThemeProp('global.link--color')};
  background: white;
  border-style: solid;
  border-width: 1px;
  border-color: ${getThemeProp('global.link--color')};
  font-weight: ${getTokenValue(THEME_TOKENS.base.fontWeight.semiBold)};
`;

const Icon = styled(Box)`
  width: 20px;
  height: 20px;
  font-size: 20px;
  margin-right: 8px;
`;

const CustomerServiceCTA = () => {
  const chatTrigger = () => {
    window.startProactiveChat();
  };

  return (
    <>
      <Questions mb={3}>
        <Text primary>Questions?</Text>
      </Questions>
      <CtaContent mb={3} justifyContent="center">
        <ChatButton onClick={chatTrigger}>
          <Flex justifyContent="center" alignItems="center">
            <Icon>
              <IconChatRound />
            </Icon>
            Live Chat
          </Flex>
        </ChatButton>
        <a href="tel:8007958371">
          <PhoneButton>
            <Flex justifyContent="center" alignItems="center">
              <Icon>
                <IconPhoneHandle />
              </Icon>
              Call
            </Flex>
          </PhoneButton>
        </a>
      </CtaContent>
    </>
  );
};

export default CustomerServiceCTA;
